import React from 'react';

import { FrequentlyAskedQuestion as BaseFaq } from '@rover/components/src/FrequentlyAskedQuestions';
import dataLayer from '@rover/globals/dataLayer';

type FrequentlyAskedQuestionProps = Omit<React.ComponentProps<typeof BaseFaq>, 'onToggle'>;

function onFaqOpen(isOpen: boolean): void {
  if (isOpen) {
    dataLayer?.push({
      event: 'city-service-landing-faq-expand-click',
    });
  }
}

/**
 * @deprecated Please use [FaqSection]({@link https://github.com/roverdotcom/web/blob/master/src/frontend/components/src/FaqSection/FaqSection.tsx}) instead.
 *
 * See [HomePageFaqs.tsx]({@link https://github.com/roverdotcom/web/blob/master/src/frontend/react-lib/src/pages/index/HomePage/components/HomePageFaqs.tsx}) for example usage.
 *
 * If the Faq Accordion is needed without the Section container, import `FaqAccordion` from [FaqSection]({@link https://github.com/roverdotcom/web/blob/master/src/frontend/components/src/FaqSection/FaqSection.tsx}) or build custom using [Accordion]({@link https://github.com/roverdotcom/web/blob/master/src/frontend/react-lib/src/components/lists/Accordion/Accordion.tsx})
 */
const FrequentlyAskedQuestion: React.FC<FrequentlyAskedQuestionProps> = (props) => {
  return <BaseFaq {...props} onToggle={onFaqOpen} />;
};

export default FrequentlyAskedQuestion;
